module.exports = __webpack_public_path__ + "img/faq-impostor-1.c24146c7.png";